import axios from "axios";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;

// Action Types
export const FETCH_LEAVES_REQUEST = "FETCH_LEAVES_REQUEST";
export const FETCH_LEAVES_SUCCESS = "FETCH_LEAVES_SUCCESS";
export const FETCH_LEAVES_FAILURE = "FETCH_LEAVES_FAILURE";

// Action Creators
export const fetchLeavesRequest = () => ({ type: FETCH_LEAVES_REQUEST });
export const fetchLeavesSuccess = (leaves) => ({
  type: FETCH_LEAVES_SUCCESS,
  payload: leaves,
});
export const fetchLeavesFailure = (error) => ({
  type: FETCH_LEAVES_FAILURE,
  payload: error,
});

// Thunk
export const fetchLeaves = () => {
  return async (dispatch) => {
    dispatch(fetchLeavesRequest());
    const token = localStorage.getItem("token");

    try {
      const res = await axios.get(`${BASE_URL}/v1/api/admin/getAllLeaves`, {
        headers: { authorization: token },
      });
      dispatch(fetchLeavesSuccess(res.data.data));
    } catch (err) {
      const errorMsg = err?.response?.data?.meta?.message || err.message;
      dispatch(fetchLeavesFailure(errorMsg));
    }
  };
};
